/**
 * The share of people or objects that carry a row.
 *
 * Rounded first, and "<1%" only for a share that rounds away to nothing:
 * the page this replaces rounds to whole percents and reserves "<1%" for a
 * non-zero share that came out as "0%"
 * (`data-index-list-table/people-cell/index.gts:22-28`, and the same rule
 * again in its drawer at `item-details/usage/index.gts:161-169`). Reading it
 * the other way round — anything under one percent is "<1%" — disagrees with
 * that page for every share between a half and one, and disagreed with this
 * one's own drawer, which already rounded.
 */
export function shareOf(withItem: number, total: number): string | null {
  if (total === 0) {
    return null;
  }

  const share = Math.round((withItem / total) * 100);
  return share === 0 && withItem > 0 ? '<1%' : `${String(share)}%`;
}
